import { FC } from 'react';
import ContractList from '../components/contract/ContractList';
import CommonPage from '../components/page/CommonPage';
import { PageTitle } from '../components/common/PageTitle';

const ContractListPage : FC= () => {

    return (
        <CommonPage selectBtnIndex={1}>
            <PageTitle title="契約一覧" />
            <ContractList />
        </CommonPage>
    )
}

export default ContractListPage;